import {Link} from "react-router-dom";
import React from "react";
import {TfiStatsDown, TfiStatsUp} from "react-icons/tfi";

const StatCard = ({ title, count, linkText, growth, icon, bgColor }) => (
    <div className="h-fit text-black flex flex-col items-start justify-between p-5 rounded-md drop-shadow-[0_0px_20px_rgba(203,229,255,0.5)] bg-white">
        <div className="w-full flex flex-col items-start gap-3.5 pb-3">
            <p className="font-medium text-[16px] text-primary">{title}</p>
            <span className="w-full flex justify-between">
                <p className="font-bold text-2xl">{count}</p>
                <div className={`flex items-center justify-center p-3 rounded-lg ${bgColor}`}>
                    {icon}
                </div>
            </span>
        </div>
        {/*<div className="w-full mt-3 flex items-center justify-between border-t-2 pt-2">*/}

        {/*    <p>Percentage Growth</p>*/}

        {/*    {growth ? (*/}
        {/*        <div className={`text-[12px] font-semi-bold px-3 py-2 rounded-md ${*/}
        {/*                growth.isPositive ? "text-green-600 bg-green-100" : "text-red-500 bg-red-100"*/}
        {/*            }`}>*/}
        {/*            <div className="flex gap-2 items-center">*/}
        {/*                {growth.isPositive ? <TfiStatsUp className="w-4 h-4"/> : <TfiStatsDown className="w-4 h-4"/>}*/}
        {/*                <span>*/}
        {/*                    {growth.value}%*/}
        {/*                </span>*/}
        {/*            </div>*/}

        {/*        </div>*/}
        {/*    ) : (*/}
        {/*        <span className="text-sm text-gray-400">0% Growth</span>*/}
        {/*    )}*/}
        {/*</div>*/}

    </div>
);

export default StatCard;